import {createContext, type PropsWithChildren, useContext} from "react";

const FederatedNavigationContext = createContext(false);

export function FederatedNavigationProvider({children}: PropsWithChildren) {
    return <FederatedNavigationContext.Provider value={true}>{children}</FederatedNavigationContext.Provider>;
}

export function useFederatedNavigation() {
    return useContext(FederatedNavigationContext);
}
